import axios from 'axios';
import React, { useState } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { backend_url } from './clientUrl';
export const VerifyOtp = () => {
               const navigate = useNavigate()
               const location = useLocation()
               const email = location.Email
               const { fromSignup,userId, Email} = location.state || {};
               const [otp,setotp] = useState("")
  const [loading, setLoading] = useState(false);
               const isAuthenticated = !!localStorage.getItem('accessToken');
               if (isAuthenticated) {
                 return <Navigate to="/" />;
               }
               if (!fromSignup) {
                return <Navigate to="/register" />;
              }
            const handleSubmit = async(e) =>{
               e.preventDefault();
               try {
                setLoading(true);
                              const { data } = await axios.post(
                                             `${backend_url}/auth/verifyotp`,
                                             {
                                                            userId,
                                                            otp
                                             }
                                           );  
                                           setLoading(false);
                                           if (data.success===true) {
                                            //  alert("OTP Verified Successfully");
                                            toast.success("Otp is Verified")
                                             navigate("/login");
                                           } else {
                                            //  alert(data.message);
                                            toast.error("otp is invalid")
                                           }        
               } catch (error) {
                       console.log(error)       
               }
            }   
           
  return (
    <>
     <div className="min-h-screen flex flex-col items-center justify-center bg-white p-4 font-Rubik">
     <div className="bg-white rounded-3xl border border-gray-200 p-8 shadow-xl w-full max-w-sm">
     <div className="flex justify-center mb-6">
          <img
            src="https://img.icons8.com/color/48/fenix.png"
            alt="Fenix"
            className="w-8 h-8"
          />
        </div>
        <h2 className="text-3xl font-bold hero-title text-center">
              REASONS
            </h2>

     <div className="mt-6 text-center">
            <p className="text-gray-500 font-rubik">
              Enter the OTP sent to your email
            </p>
            <div className="flex justify-between mt-4">
            <form onSubmit={handleSubmit}>
                <input
                   type="text"
        placeholder="Enter OTP"
        value={otp}
        onChange={(e) => setotp(e.target.value)}
        required
                  className="border border-gray-300 p-4 font-rubik rounded-full w-full focus:outline-none focus:ring-2 focus:ring-gray-500 transition duration-200 text-center"
                />
            <button  disabled={loading || otp.trim() === ""} className="relative w-full font-rubik py-3 mt-6 bg-black text-white rounded-full text-lg hover:bg-gray-600 transition duration-200">
            {loading ? "Verifying..." : "Verify OTP"}
            </button>
            </form>
          </div>
          </div>
          </div>
          </div>

    {/* <div className="flex flex-col items-center w-[50%]  absolute top-[20%] left-[50%] translate-x-[-50%] translate-y-[-20%]">
    <h1 className='text-[1.8rem] m-5 font-semibold '>Verification</h1>
    <p className='text-slate-500'>You Will Get Verification to Your mail "{Email}"</p>
             <form onSubmit={handleSubmit} className='flex flex-col w-1/2'>
      <input
        type="text"
        placeholder="Enter OTP"
        value={otp}
        onChange={(e) => setotp(e.target.value)}
        required
         className="m-3 p-1  px-3 border-2 rounded-md outline-2 outline-slate-500 text-center"
      />
        <button 
                    disabled={loading || otp.trim() === ""} // Enable only if OTP is entered and not loading
                    className={`bg-gray-800 m-3 p-1 text-white ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                    {loading ? "Verifying..." : "Verify OTP"}
                </button>
    </form>
    </div> */}
    </>
  )
}
